import {
  Alert,
  BreadcrumbGroup,
  Button,
  ContentLayout,
  Header,
  SpaceBetween,
  Table,
} from '@amzn/awsui-components-react';
import { useCallback, useEffect, useState } from 'react';

import { listReadyDishes, ReadyDish } from '../api/workshop';
import Layout from '../components/Layout';
import { UIPath } from '../paths';

export default function ReadyDishes() {
  const [dishes, setDishes] = useState<ReadyDish[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      setDishes(await listReadyDishes());
      setError(false);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <Layout
      breadcrumbs={
        <BreadcrumbGroup
          items={[
            { text: 'Home', href: UIPath.Landing },
            { text: 'Kitchen Pass', href: UIPath.ReadyDishes },
          ]}
          ariaLabel='Breadcrumbs'
        />
      }
      content={
        <ContentLayout header={<Header variant='h1'>Kitchen pass</Header>}>
          <SpaceBetween size='l'>
            <Button loading={loading} onClick={refresh}>
              Refresh
            </Button>
            {error && <Alert type='error'>Unable to load ready dishes from ExpoService.</Alert>}
            <Table
              loading={loading}
              items={dishes}
              empty='No dishes are ready.'
              columnDefinitions={[
                { id: 'dish', header: 'Dish', cell: (dish) => dish.dishName },
                { id: 'participant', header: 'Participant', cell: (dish) => dish.participantId },
                { id: 'order', header: 'Order', cell: (dish) => dish.orderId },
                { id: 'readyAt', header: 'Ready at', cell: (dish) => dish.readyAt },
                { id: 'status', header: 'Status', cell: (dish) => dish.status },
              ]}
            />
          </SpaceBetween>
        </ContentLayout>
      }
    />
  );
}
